"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _QuestionFill = _interopRequireDefault(require("../../icons-react/rebrand/QuestionFill"));
var _Bubble = _interopRequireDefault(require("../Bubble"));
var _tagTypes = require("./utils/tagTypes");
var _Image = _interopRequireDefault(require("../Image"));
var HotelCardTag = function HotelCardTag(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    type = _ref.type,
    className = _ref.className,
    tooltipText = _ref.tooltipText,
    icon = _ref.icon;
  var tagBody = type ? _tagTypes.TYPES[type] : undefined;
  var tagTooltip = tooltipText || (tagBody === null || tagBody === void 0 ? void 0 : tagBody.tooltipText) || '';
  var tagIcon = icon ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    src: icon,
    fallback: ""
  }) : tagBody === null || tagBody === void 0 ? void 0 : tagBody.icon;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledHotelCardTag, {
    className: className
  }, tagIcon && /*#__PURE__*/_react["default"].createElement(StyledIcon, null, tagIcon), /*#__PURE__*/_react["default"].createElement("span", null, text || (tagBody === null || tagBody === void 0 ? void 0 : tagBody.text)), tagTooltip && /*#__PURE__*/_react["default"].createElement(StyledBubble, {
    width: "normal",
    text: tagTooltip
  }, /*#__PURE__*/_react["default"].createElement(StyledQuestionFillIcon, null))));
};
var StyledHotelCardTag = _styledComponents["default"].span.withConfig({
  displayName: "HotelCardTag__StyledHotelCardTag",
  componentId: "sc-1eqasib-0"
})(["color:var(--black);font-size:14px;font-style:normal;font-weight:400;display:flex;align-items:center;cursor:default;"]);
var StyledIcon = _styledComponents["default"].span.withConfig({
  displayName: "HotelCardTag__StyledIcon",
  componentId: "sc-1eqasib-1"
})(["width:16px;height:16px;margin-right:4px;"]);
var StyledBubble = (0, _styledComponents["default"])(_Bubble["default"]).withConfig({
  displayName: "HotelCardTag__StyledBubble",
  componentId: "sc-1eqasib-2"
})(["display:inline-flex;"]);
var StyledQuestionFillIcon = (0, _styledComponents["default"])(_QuestionFill["default"]).withConfig({
  displayName: "HotelCardTag__StyledQuestionFillIcon",
  componentId: "sc-1eqasib-3"
})(["margin-left:4px;height:16px;path{fill:var(--grey2);}"]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelCardTag);